import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatSidenav } from "@angular/material/sidenav";
import { Router } from "@angular/router";
import {
  getQueryParam,
  setActualDimensions,
} from "src/app/features/liveshop/utils/helpers";
import { StoresService } from "src/app/services/catalog/stores.service";
import { ImagesService } from "src/app/services/images/images.service";
import { LiveshopService } from "src/app/services/liveshop/liveshop.service";
import { PromolinkAuthorizationService } from "src/app/services/orderlinks/promolink-authorization.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { TRANSLATE } from "src/environments/config";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { icons } from "../../../../environments/config";

@Component({
  selector: "app-cart-header",
  templateUrl: "./cart-header.component.html",
  styleUrls: ["./cart-header.component.scss"],
})
export class CartHeaderComponent implements OnInit, OnChanges {
  logoSource;
  isCartEnabled;
  currentBusinessUnit;
  boardType;
  @Input() data;
  @Input() cartLength;
  @Input() fromCart;
  @Input() fromSummary;
  @Output() openCart: EventEmitter<any> = new EventEmitter();
  @Output() openWishlist: EventEmitter<any> = new EventEmitter();
  @Output() shareLink: EventEmitter<any> = new EventEmitter();
  @Output() changePassword: EventEmitter<any> = new EventEmitter();
  @Output() goToMyProfile: EventEmitter<any> = new EventEmitter();
  @Output() menuActions: EventEmitter<any> = new EventEmitter();
  @Output() loginDialogOpen: EventEmitter<any> = new EventEmitter();
  @Output() logOut: EventEmitter<any> = new EventEmitter();
  @Output() openDialog: EventEmitter<any> = new EventEmitter();
  @Output() onPreviewClick: EventEmitter<any> = new EventEmitter();
  @Output() removeCartProduct: EventEmitter<any> = new EventEmitter();
  @Output() checkout: EventEmitter<any> = new EventEmitter();
  @Output() changeBoard: EventEmitter<any> = new EventEmitter();
  @Output() redirectToLandingPage: EventEmitter<any> = new EventEmitter();
  @ViewChild("collectionsListDrawer") collectionsListDrawer: MatSidenav;
  @ViewChild("clickProfileMenuTrigger") public profileMenu: MatMenuTrigger;
  isEuropean =
    TRANSLATE.value === "ENABLE_TRANSLATION" &&
    location.href.includes("isCustomized");
  showBookings: any;
  showWishList: any;
  showOrders: any;
  hideProfile = false;
  public icons = icons;
  ARDialog: boolean = false;
  hide3DProfile: any = false;
  public defaultImage = icons.businessUserIcon.defaultImg;
  defaultMaleImage = "modules/users/img/profile/male.svg";
  defaultFemaleImage = "modules/users/img/profile/female.svg";
  defaultOtherImage = "modules/users/img/profile/other.svg";
  isMobileDevice;
  isTabDevice;
  constructor(
    public valuChainUserService: UserService,
    public LiveshopService: LiveshopService,
    public slotService: SlotService,
    public imagesService: ImagesService,
    public cdRef: ChangeDetectorRef,
    public storesService: StoresService,
    public promoLinkAuthorizationService: PromolinkAuthorizationService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.currentBusinessUnit = this.LiveshopService?.appointmentDetails?.owner?.businessUnit;
    const config = JSON.parse(
      localStorage.getItem("busConfig")
        ? localStorage.getItem("busConfig")
        : localStorage.getItem("config")
        ? localStorage.getItem("config")
        : localStorage.getItem("companyConfig")
    );
    const url = new URL(window.location.href);
    const params = url.searchParams;
    let embed = params.get("isEmbedded");
    const companyconfig = JSON.parse(
      localStorage.getItem("busConfig")
        ? localStorage.getItem("busConfig")
        : localStorage.getItem("companyConfig")
        ? localStorage.getItem("companyConfig")
        : localStorage.getItem("config")
    );
    this.hideProfile =
      this.slotService.isSTLPromolink || this.data.isRoomPlan
        ? companyconfig?.whiteshop?.stl?.hideProfile
        : companyconfig?.whiteshop?.hideProfileFor3dBoard && !embed;
    if (
      config &&
      config.whiteshop.companyLogo &&
      config.whiteshop.companyLogo.length
    ) {
      this.logoSource = config.whiteshop.companyLogo;
    } else {
      this.logoSource = "assets/icons/Shopconnect_logo_new.png";
    }
    if (sessionStorage.getItem("currentBusinessUnit")) {
      this.isCartEnabled = JSON.parse(
        sessionStorage.getItem("currentBusinessUnit")
      ).settings.whiteshop.isSelectionsCartEnabled;
    } else {
      this.valuChainUserService
        .getCurrentBusinessUnitData(sessionStorage.getItem("businessUnit"))
        .subscribe((res) => {
          this.slotService.removePaymentModesAndTerms(res);
          sessionStorage.setItem("currentBusinessUnit", JSON.stringify(res));
          this.isCartEnabled =
            res["settings"].whiteshop.isSelectionsCartEnabled;
        });
    }
    this.showBookings = config?.whiteshop?.isScheduledAppointmentsEnabled;
    this.showWishList = config?.whiteshop?.enableWishlist;
    this.showOrders = config?.whiteshop?.isCheckoutProcessEnabled;
    this.data.isCartMenuOpened = false;
    if (getQueryParam("ARDialog", this.router)) {
      this.ARDialog = true;
    }
    this.hide3DProfile =
      this.slotService.isSTLPromolink || this.data.isRoomPlan
        ? companyconfig?.whiteshop?.stl?.hideProfile
        : companyconfig?.whiteshop?.hideProfileFor3dBoard;
    this.boardType = getQueryParam("boardType", this.router);
    this.setDimensions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.data.cartItems);
    this.cdRef.detectChanges();
  }

  setDimensions() {
    const dimensions = setActualDimensions();
    this.isMobileDevice = dimensions.windowWidth <= 6;
    this.isTabDevice =
      dimensions.windowWidth > 6 && dimensions.windowWidth <= 12;
  }

  loggedIn() {
    return localStorage.getItem("user");
  }

  checkCartValidity() {
    return this.currentBusinessUnit.settings.whiteshop.isSelectionsCartEnabled;
  }
  isRetailer() {
    return localStorage.getItem("retailerToken");
  }

  checkChatValidity(type?) {
    if (
      this.currentBusinessUnit &&
      this.currentBusinessUnit.settings &&
      this.currentBusinessUnit.settings.whiteshop
    ) {
      switch (type) {
        case "call":
          return this.currentBusinessUnit.settings.whiteshop
            .isSelectionsVideoCallEnabled;
        case "chat":
          return this.currentBusinessUnit.settings.whiteshop
            .isSelectionsChatEnabled;
        case "cart":
          return this.currentBusinessUnit.settings.whiteshop
            .isSelectionsCartEnabled;
        case "scheduleAppointment":
          return this.currentBusinessUnit.settings.whiteshop
            .isSelectionsScheduledAppointmentsEnabled;
        default:
          return (
            this.checkChatValidity("call") ||
            this.checkChatValidity("chat") ||
            this.checkChatValidity("scheduleAppointment")
          );
      }
    } else {
      return true;
    }
  }

  clickMenu() {
    this.collectionsListDrawer.toggle();
    this.data.showMenu = true;
    this.data.gridView = false;
  }

  closeMenuAction() {
    setTimeout(() => {
      this.collectionsListDrawer.close();
    }, 100);
    this.data.showMenu = false;
    this.data.showPopup = false;
  }
  checkProfileMenu() {
    if (this.loggedIn()) {
      this.profileMenu.openMenu();
    } else {
      this.profileMenu.closeMenu();
      this.loginDialogOpen.emit();
    }
  }

  closeCartMenu() {
    this.data.isCartMenuOpened = !this.data.isCartMenuOpened;
    document
      .getElementById("ws-body")
      .classList.remove("cdk-global-scrollblock");
  }

  cartOpenLoginCheck() {
    document.getElementById("ws-body").classList.add("cdk-global-scrollblock");
    this.data.isCartMenuOpened = !this.data.isCartMenuOpened;
    this.data.menuCount = 0;
  }

  goToFooter() {
    const el = document.getElementById("footerCBCart");
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }

  isUserUploadedImage() {
    return (
      this.loggedIn() &&
      !(
        !(
          this.LiveshopService.currentUser &&
          this.LiveshopService.currentUser.profileImageURL
        ) ||
        this.LiveshopService.currentUser?.profileImageURL ===
          this.defaultImage ||
        this.LiveshopService.currentUser?.profileImageURL ===
          this.defaultMaleImage ||
        this.LiveshopService.currentUser?.profileImageURL ===
          this.defaultFemaleImage ||
        this.LiveshopService.currentUser?.profileImageURL ===
          this.defaultOtherImage
      )
    );
  }
}
